/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AccountEventRequest, AccountEventsResponse } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AccountEvent<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name AccountEventCreate
   * @request POST:/account-event
   */
  accountEventCreate = (data: AccountEventRequest, params: RequestParams = {}) =>
    this.request<AccountEventsResponse, any>({
      path: `/account-event`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
